import PropTypes from "prop-types";
import { Paper, Table, TableContainer } from "@mui/material";

export default function CatalogMaintenanceTable({
  head,
  body,
  tableLoading = false,
  tableLayout = "fixed",
  tableMinWidth,
  maxHeight,
}) {
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      className={`cm-panel cm-table-shell${tableLoading ? " is-loading" : ""}`}
      sx={maxHeight ? { maxHeight } : undefined}
    >
      <Table
        stickyHeader
        className="cm-table"
        sx={{
          tableLayout,
          minWidth: tableMinWidth || undefined,
          width: tableMinWidth ? tableMinWidth : "100%",
        }}
      >
        {head}
        {body}
      </Table>
    </TableContainer>
  );
}

CatalogMaintenanceTable.propTypes = {
  head: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  tableLoading: PropTypes.bool,
  tableLayout: PropTypes.oneOf(["auto", "fixed"]),
  tableMinWidth: PropTypes.number,
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

